import { useFeatureFlagsQuery } from 'src/hooks/queries/featureFlag';

const useFeatureFlag = (name: string) => {
  const { data } = useFeatureFlagsQuery();
  return data?.includes(name);
};

export default useFeatureFlag;
